<template>
  <div class="projects-list-page">
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                  Projects
                </h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-tabs lazy>
                  <b-tab title="Active" :active="!wantsSharedTab">
                    <b-card
                      border-variant="light"
                      bg-variant="light"
                      body-class="px-0 py-0"
                    >
                      <project-list
                        ref="activeProjectList"
                        :showArchived="false"
                      />
                    </b-card>
                  </b-tab>
                  <b-tab title="Archived">
                    <b-card
                      border-variant="light"
                      bg-variant="light"
                      body-class="px-0 py-0"
                    >
                      <project-list :showArchived="true" />
                    </b-card>
                  </b-tab>
                  <b-tab
                    v-if="canShareProject"
                    title="Shared"
                    :active="wantsSharedTab"
                  >
                    <b-card
                      border-variant="light"
                      bg-variant="light"
                      body-class="px-0 py-0"
                    >
                      <shared-project-list @shares-changed="onSharesChanged" />
                    </b-card>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectList from '@/components/lists/ProjectList'
import SharedProjectList from '@/components/lists/SharedProjectList'

export default {
  components: {
    ProjectList,
    SharedProjectList,
  },

  computed: {
    ...mapGetters('auth', ['user', 'hasPermission']),

    canShareProject() {
      if (!this.user || this.user.user_type !== 'business_admin') return false
      return this.hasPermission('projects.share')
    },

    // Lets a "shared project" notification deep-link straight to the Shared
    // tab (?tab=shared) instead of always landing on Active. Bound directly
    // via each <b-tab>'s own `active` prop (reactive in bootstrap-vue), so it
    // also re-applies correctly if the query changes while already on this
    // page (a query-only navigation reuses this component instance).
    wantsSharedTab() {
      return this.$route.query.tab === 'shared' && this.canShareProject
    },
  },

  methods: {
    onSharesChanged() {
      const list = this.$refs.activeProjectList
      if (list && typeof list.refreshShareLocks === 'function') {
        list.refreshShareLocks()
      }
    },
  },
}
</script>

<style scoped>
/* The fixed navbar wraps to two rows on small screens (taller than the desktop
   navbar the page clearance is sized for), so the "Projects" title ends up
   cramped against it — add extra top spacing on phones/tablets. */
@media (max-width: 767.98px) {
  .projects-list-page {
    padding-top: 0.5rem;
  }
}
</style>
